import _regeneratorRuntime from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/home/ubuntu/BookingSystemV2/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
  * ------------ plugins --------------
  * */
import axios from '~/plugins/axios.js';
import domain from '~/plugins/domain.js';

/*
  * ------------ components ------------
  * */
import ModuleSessionList from '~/components/mainPage/ModuleSessionList';
import EditMsModalPanel from '~/components/mainPage/EditMsModalPanel.vue';
import Loading from '~/components/Loading.vue';

export default {
  name: 'main-page',
  components: {
    ModuleSessionList: ModuleSessionList,
    EditMsModalPanel: EditMsModalPanel,
    Loading: Loading
  },
  data: function data() {
    var minDate = '';
    if (this.$store.state.authUser.flag == 'Admin') {
      minDate = '20170101';
    } else {
      minDate = String(this.$moment().add('d', 1).format('YYYYMMDD'));
    }

    return {
      isLoading: true,
      showDate: new Date(),
      currentDateRaw: this.$moment(this.showDate).format('YYYYMMDD').toString(), // Date.now(),
      show_EditPanel: false,
      minDate: minDate,
      msId: 'dummyId',
      wholeMonthMsList: [],
      moduleSessionBookingModalData: {}
    };
  },

  // async asyncData(){
  //   return {
  //     wholeMonthMsList: (await axios.post('/moduleSession/wholeMonthModuleSessions', {today: new Date()})).data
  //   }
  // },
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          redirect = _ref.redirect;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (store.state.authUser) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', redirect('/'));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),
  mounted: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log('\n\n ======== cal comp mounted ======= \n');
              _context2.next = 3;
              return this.initModuleSessionList();

            case 3:
              _context2.next = 5;
              return this.initWholeMonthMsList();

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function mounted() {
      return _ref3.apply(this, arguments);
    }

    return mounted;
  }(),
  updated: function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log('\n\n ======== cal comp updated =======\n', this.currentDateRaw);
              _context3.next = 3;
              return this.initModuleSessionList();

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function updated() {
      return _ref4.apply(this, arguments);
    }

    return updated;
  }(),

  methods: {
    setShowDate: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(d) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.showDate = d;
                console.log('\n\n ====== MainPage<|-- setShowDate() d =====\n', d, '\n ----------');
                console.log('\n\n ====== MainPage<|-- setShowDate() d =====\n', this.$moment(d).month(), '\n ----------');
                this.currentDateRaw = this.$moment(this.showDate).format('YYYYMMDD').toString();
                _context4.next = 6;
                return this.initModuleSessionList();

              case 6:
                _context4.next = 8;
                return this.initWholeMonthMsList();

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setShowDate(_x2) {
        return _ref5.apply(this, arguments);
      }

      return setShowDate;
    }(),
    initModuleSessionList: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var moduleSessionList, _moduleSessionList;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.$store.state.authUser.flag === 'Admin' || this.$store.state.authUser.flag === 'Con' || this.$store.state.authUser.flag === 'Trn')) {
                  _context5.next = 11;
                  break;
                }

                this.$store.commit('setDateRaw', this.currentDateRaw);

                _context5.next = 4;
                return axios.post('/moduleSession/', {
                  currentDateRaw: this.currentDateRaw,
                  moduleName: null
                });

              case 4:
                moduleSessionList = _context5.sent.data.moduleSessionList;


                console.log('\n\n====== current date ======\n', this.currentDateRaw, '\n========');
                console.log('\n\n====== module session list of the day ======\n', moduleSessionList, '\n========');
                this.$store.commit('setModuleSessionList', moduleSessionList);
                this.isLoading = false;
                _context5.next = 24;
                break;

              case 11:
                if (!(Number(this.$moment(this.currentDateRaw).format('X')) - Number(this.$moment(this.$moment().format('YYYYMMDD').toString()).format('X')) >= 3600 * 24)) {
                  _context5.next = 22;
                  break;
                }

                this.$store.commit('setDateRaw', this.currentDateRaw);
                _context5.next = 15;
                return axios.post('/moduleSession/', {
                  currentDateRaw: this.currentDateRaw,
                  moduleName: null
                });

              case 15:
                _moduleSessionList = _context5.sent.data.moduleSessionList;

                console.log('\n\n====== current date ======\n', this.currentDateRaw, '\n========');
                console.log('\n\n====== module session list of the day ======\n', _moduleSessionList, '\n========');
                this.$store.commit('setModuleSessionList', _moduleSessionList);
                this.isLoading = false;
                _context5.next = 24;
                break;

              case 22:
                console.log('\n\n ======== time constraint =======\n');
                this.isLoading = false;

              case 24:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initModuleSessionList() {
        return _ref6.apply(this, arguments);
      }

      return initModuleSessionList;
    }(),
    initWholeMonthMsList: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var msList;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return axios.post('/moduleSession/wholeMonthModuleSessions', { today: this.showDate });

              case 2:
                msList = _context6.sent.data.msList;

                console.log('\n\n ======= mainPage <|-- initWholeMonthMsList ======\n', msList, '\n ------------------');
                this.wholeMonthMsList = msList;
                return _context6.abrupt('return', msList);

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function initWholeMonthMsList() {
        return _ref7.apply(this, arguments);
      }

      return initWholeMonthMsList;
    }(),
    popUpEventModal: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(moduleEvent) {
        var moduleSession;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return axios.get('/moduleSession/' + moduleEvent.id);

              case 2:
                moduleSession = _context7.sent.data;

                // const moduleSession = (await domain.get('moduleSession', event.id)).data;

                this.moduleSessionBookingModalData = moduleSession;
                // this.moduleSessionBookingModalData = {
                //   moduleSessionId: moduleSession.id,
                //   title: moduleSession.moduleName,
                //   trainerName: moduleSession.trainerName,
                //   language: moduleSession.language,
                //   roomId: moduleSession.roomId,
                //   sessionTime: this.$moment(moduleSession.sessionTime, 'X').format('DD-MM-YYYY HH:mm'),
                //   seatTaken: moduleSession.seatTaken,
                //   seatTotal: moduleSession.seatTotal
                // }

                this.$refs.moduleSessionBookingModal.show();
                console.log('\n\n ======= mainPage <|-- Modal <|-- moduleSession ====== \n', moduleSession, '\n ------------------------');

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function popUpEventModal(_x3) {
        return _ref8.apply(this, arguments);
      }

      return popUpEventModal;
    }(),
    showEditPanel: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.$refs.moduleSessionBookingModal.hide();
                this.$store.commit('setModuleSession', this.moduleSessionBookingModalData);
                this.$refs.editModuleSessionModal.show();

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function showEditPanel() {
        return _ref9.apply(this, arguments);
      }

      return showEditPanel;
    }(),
    updateModuleSessionInfo: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(moduleInfo) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log('\n\n ======= Whole Month Cal <}-- updateModuleSessionInfo() ====== \n', moduleInfo, '\n ----------');

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function updateModuleSessionInfo(_x4) {
        return _ref10.apply(this, arguments);
      }

      return updateModuleSessionInfo;
    }()
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/mainPage/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/mainPage/index.vue
// module chunks = 6